import React, { useContext } from 'react';
import './AverageResponse.css';
import ModuleLoadingStatus from '../ModuleLoadingStatus/ModuleLoadingStatus';
import { CardAverageResponseContext } from '../../contexts/CardAverageResponseContext';
import logComponent from '../../common/logComponent';

export default function AverageAlarmResponseLoadingStatus({ reloadAction }) {
  const cardAverageResponseContext = useContext(CardAverageResponseContext);
  const { averageResponseLoading, averageResponseError } = cardAverageResponseContext;

  if (logComponent('AverageAlarmResponseLoadingStatus')) { console.debug('AverageAlarmResponseLoadingStatus rendered'); }


  return (
    <ModuleLoadingStatus isLoading={averageResponseLoading} isError={averageResponseError} reloadAction={reloadAction} />
  );
}